import type {
  I18n,
  I18nDefinition,
  I18nValues,
} from '@backmarket/nuxt-module-i18n/types/i18n'

/**
 * This type is used to define a value that can be either a string or an I18nDefinition.
 */
export type MaybeI18nDefinition = I18nDefinition | string

/**
 * Helper function to create a i18n function that can handle both string and I18nDefinition.
 * @example
 * const i18n = maybeI18n(i18nInstance)
 * const message = i18n({ id: 'my.message', defaultMessage: 'My message' })
 * // or
 * const message = i18n('My message')
 */
export function maybeI18n(i18n: I18n) {
  return (valueOrDefinition: MaybeI18nDefinition, values?: I18nValues) => {
    if (typeof valueOrDefinition === 'string') {
      return valueOrDefinition
    }

    return i18n(valueOrDefinition, values)
  }
}

export function getDefaultMessage(valueOrDefinition: MaybeI18nDefinition) {
  if (typeof valueOrDefinition === 'string') {
    return valueOrDefinition
  }

  return valueOrDefinition.defaultMessage
}
